import React from "react";
import { connect } from "react-redux";
import { styled } from "@mui/material/styles";
import Task from "./Task";
import { Droppable } from "react-beautiful-dnd";
// import styled from 'styled-components';
import { Paper, Typography, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import dataService from "../../common/services/dataService";
import Button from "@mui/material/Button";
import { CellStepManagementOperations } from "../../CellStepManagement/duck/index";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { withRouter } from "react-router-dom";

const PREFIX = "Column";

const classes = {
  paperStandard: `${PREFIX}-paperStandard`,
  paperDense: `${PREFIX}-paperDense`,
  cellTitleStandard: `${PREFIX}-cellTitleStandard`,
  cellTitleDense: `${PREFIX}-cellTitleDense`,
  titleDense: `${PREFIX}-titleDense`,
  subTitleDense: `${PREFIX}-subTitleDense`,
};

const Root = styled("div")({
  [`& .${classes.paperStandard}`]: {
    width: "380px",
    padding: 16,
    borderRadius: 6,
  },
  [`& .${classes.paperDense}`]: {
    width: "240px",
    padding: 8,
    borderRadius: 6,
  },
  [`& .${classes.cellTitleStandard}`]: {
    display: "flex",
    justifyContent: "space-between",
  },
  [`& .${classes.cellTitleDense}`]: {
    display: "flex",
    flexDirection: "column-reverse",
  },
  [`& .${classes.titleDense}`]: {
    fontSize: "1rem",
  },
  [`& .${classes.subTitleDense}`]: {
    fontSize: "10px",
  },
});

const TaskList = styled("div")(({ theme }) => ({}));
const colors = [
  "#42a5f5",
  "#66bb6a",
  "#ffa726",
  "#7e57c2",
  "#26a69a",
  "#ffca28",
  "#ff7043",
  "#5c6bc0",
  "#ab47bc",
  "#26c6da",
  "#ffee58",
  "#ec407a",
  "#29b6f6",
  "#d4e157",
  "#ef5350",
];

class Column extends React.Component {
  state = {
    title: this.props.column.cellName,
    shortName: this.props.column.shortName || "",
    titleFormFocus: false,
    duplicatedColumn: null, 
    copyCount: 0, 
    addingValidation: false,
    showValidationConfirm: false,
    snackbarOpen: false,
    snackbarMessage: "",
    snackbarSeverity: "error",
  };

  onTitleType = (e) => {
    const title = e.target.value;
    this.setState({ title });
  };

  onShortNameType = (e) => {
    const shortName = e.target.value;
    this.setState({ shortName });
  };

  onTitleClickToggle = () => {
    this.setState((prevState) => ({
      titleFormFocus: !prevState.titleFormFocus,
    }));
  };

  onTitleChange = (e, TYPE) => {
    const { column, onTitleChange } = this.props;
    const { title, shortName } = this.state;
    if (TYPE === "TITLE") {
      onTitleChange(column.id, title, TYPE);
    } else {
      onTitleChange(column.id, shortName, TYPE);
    }
    this.onTitleClickToggle();
  };

  onDuplicateClick = () => {
    const { column, onDuplicateColumn } = this.props;

    const studyId = localStorage.getItem("studyId");

    if (!studyId) {
      console.error("No studyId found in localStorage.");
      return;
    }

    if (onDuplicateColumn) {
      onDuplicateColumn(column, studyId);
    }
  };

  // add validation (no new page)
  onConfirmAddValidation = async () => {
    const { column } = this.props;
    const studyId = localStorage.getItem("studyId");

    if (!studyId) {
      console.error("No study id found in local storage");
      this.setState({
        snackbarOpen: true,
        snackbarMessage: "Missing study id. Please try again.",
        snackbarSeverity: "error",
      });
      return;
    }

    if (!column?.id) {
      console.error("Missing column id: ", column);
      this.setState({
        snackbarOpen: true,
        snackbarMessage: "Missing cell id. Please try again.",
        snackbarSeverity: "error",
      });
      return;
    }

    if (this.state.addingValidation) return;

    try {
      this.setState({ addingValidation: true });

      const res = await this.props.addTask(
        column.id,
        "Validation",
        studyId,
        "Validation",
        null,
        null,
        false,
        false
      );

      const responseData = res?.data || res;

      if (responseData && responseData.success === false) {
        const backendMessage =
          responseData.error ||
          responseData.reason ||
          responseData.message ||
          "";

        const friendlyMessage =
          backendMessage
            .toLowerCase()
            .includes("exceeded validation step count for cell")
            ? "There is a hard limit on the number of Validation steps and further cannot be added. If you need the limit to be increased due to the nature of the study please contact the Tech team."
            : backendMessage || "Failed to add validation step.";

        this.setState({
          snackbarOpen: true,
          snackbarMessage: friendlyMessage,
          snackbarSeverity: "error",
          showValidationConfirm: false,
        });
        return;
      }

      this.setState({
        snackbarOpen: true,
        snackbarMessage: "Validation step added successfully.",
        snackbarSeverity: "success",
        showValidationConfirm: false,
      });
    } catch (e) {
      console.error("Failed to add validation step: ", e);

      this.setState({
        snackbarOpen: true,
        snackbarMessage: this.getValidationErrorMessage(e),
        snackbarSeverity: "error",
        showValidationConfirm: false,
      });
    }finally {
      this.setState({ addingValidation: false });
    }
  };

  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  getValidationErrorMessage = (e) => {
    const backendMessage =
      e?.response?.data?.error ||
      e?.response?.data?.reason ||
      e?.response?.data?.message ||
      e?.message ||
      "";

    if (
      backendMessage
        .toLowerCase()
        .includes("exceeded validation step count for cell")
    ) {
      return "There is a hard limit on the number of Validation steps and further cannot be added. If you need the limit to be increased due to the nature of the study please contact the Tech team";
    }

    return "Failed to add validation step.";
  };

  render() {
    const {
      column,
      handleClick,
      tasks,
      onDeleteClick,
      onHamburburgerClick,
      allowEditing,
    } = this.props;
    const { titleFormFocus, duplicatedColumn, addingValidation, showValidationConfirm } = this.state;
    // const { = {} } = this.props;

    return (
      <Root
        style={{
          display: "flex",
          flexDirection: "row",
          margin: "10px",
          flexWrap: "wrap",
        }}
      >
        {/* Flex container for side-by-side layout */}
        <Paper
          elevation={this.props.density === "dense" ? 2 : 3}
          className={
            this.props.density === "dense"
              ? classes.paperDense
              : classes.paperStandard
          }
          style={{
            borderTop:
              this.props.density === "dense"
                ? `6px solid ${colors[this.props.indexOrder]}`
                : `8px solid ${colors[this.props.indexOrder]}`,
            minWidth: "300px",
          }}
        >
          <Droppable
            droppableId={String(column.id)}
            key={String(column.id)}
          >
            {(provided) => (
              <TaskList
                className="csm__task-list"
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ border: "unset", margin: "unset" }}
              >
                <div
                  className={
                    this.props.density === "dense"
                      ? classes.cellTitleDense
                      : classes.cellTitleStandard
                  }
                >
                  <div>
                    {titleFormFocus ? (
                      <>
                        <TextField
                          style={{ margin: "8px 4px 8px 1px" }}
                          size="small"
                          id="long"
                          label="Long name"
                          variant="outlined"
                          onBlur={(e) => this.onTitleChange(e, "TITLE")}
                          onChange={this.onTitleType}
                          value={this.state.title}
                        />
                        <TextField
                          style={{ margin: "8px 4px 8px 1px" }}
                          size="small"
                          inputProps={{ maxLength: 20 }}
                          id="short"
                          label="Short name"
                          variant="outlined"
                          maxLength={4}
                          onBlur={(e) => this.onTitleChange(e, "SUBTITLE")}
                          onChange={this.onShortNameType}
                          value={this.state.shortName}
                        />
                      </>
                    ) : (
                      <>
                        <Tooltip
                          arrow
                          placement="left"
                          disableHoverListener={column.cellName.length <= 19}
                          title={column.cellName}
                        >
                          <Typography
                            variant="h6"
                            className={
                              this.props.density === "dense"
                                ? classes.titleDense
                                : ""
                            }
                            component={"span"}
                          >
                            {column.cellName.length > 19
                              ? `${column.cellName.substring(0, 18)}...`
                              : column.cellName}
                          </Typography>
                        </Tooltip>
                        <Typography
                          className={
                            this.props.density === "dense"
                              ? classes.subTitleDense
                              : ""
                          }
                          style={{ margin: 0 }}
                          variant="body2"
                          color="textSecondary"
                          component={"span"}
                        >
                          {column.shortName}
                        </Typography>
                      </>
                    )}
                  </div>

                  <div
                    style={{
                      whiteSpace: "nowrap",
                      marginBottom: 4,
                      alignSelf:
                        this.props.density === "dense" ? "flex-end" : "",
                    }}
                  >
                    <Tooltip arrow placement="top" title="Duplicate cell">
                      <IconButton
                        onClick={this.onDuplicateClick}
                        style={{ borderRadius: "6px", margin: 2 }}
                        aria-label="duplicate"
                        size="small"
                      >
                        <FileCopyOutlinedIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip arrow placement="top" title="Rename cell">
                      <IconButton
                        onClick={this.onTitleClickToggle}
                        style={{ borderRadius: "6px", margin: 2 }}
                        aria-label="delete"
                        size="small"
                      >
                        <EditOutlinedIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip arrow placement="top" title="Number of steps">
                      <Typography
                        noWrap
                        variant="subtitle2"
                        component={"span"}
                        style={{
                          display: "inline",
                          margin: 2,
                          background: "rgba(85, 105, 255, 0.1)",
                          color: "rgb(85, 105, 255)",
                          maxHeight: "24px",
                          padding: "2px 8px",
                          borderRadius: "6px",
                        }}
                      >
                        <b>{tasks.length}</b>
                      </Typography>
                    </Tooltip>
                  </div>
                </div>

                {tasks.map((task, index) => (
                  <Task
                    density={this.props.density}
                    onDeleteClick={(id) => onDeleteClick(id, column.id)}
                    onHamburburgerClick={(id) =>
                      onHamburburgerClick(id, column.id)
                    }
                    key={String(task.id || task.step_order_id)}
                    task={task}
                    index={index}
                    allowEditing={allowEditing}
                  />
                ))}
                {provided.placeholder}

                {/* Add the "Add new step" button inside the column, at the bottom */}
                {allowEditing && (
                  <div style={{ marginTop: "auto", padding: "8px" }}>
                    {" "}
                    <div style={{ display: "flex", gap: "6px", justifyContent: "center", flexWrap: "nowrap" }}>
                      <Tooltip title="Add Control Step" placement="top">
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "#000",
                            textTransform: "none",
                            whiteSpace: "nowrap",
                            padding: "4px 8px",
                            minWidth: "70px",
                            fontSize: "0.8rem"
                          }}
                          onClick={() => {
                            const studyId = localStorage.getItem("studyId");
                            this.props.history.push({
                              pathname: `/my_studies/overview/${studyId}/cell_step_management/${column.id}/add-step/control`,
                              state: { columnId: column.id, stepCategory: "Control" },
                            });
                          }}
                        >
                          + Control
                        </Button>
                      </Tooltip>

                      <Tooltip title="Add Stim Step" placement="top">
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "#000",
                            textTransform: "none",
                            whiteSpace: "nowrap",
                            padding: "4px 8px",
                            minWidth: "70px",
                            fontSize: "0.8rem"
                          }}
                          onClick={() => {
                            const studyId = localStorage.getItem("studyId");
                            this.props.history.push({
                              pathname: `/my_studies/overview/${studyId}/cell_step_management/${column.id}/add-step/stim`,
                              state: { columnId: column.id, stepCategory: "Stim" },
                            });
                          }}
                        >
                          + Stim
                        </Button>
                      </Tooltip>

                      <Tooltip title="Add Question Step" placement="top">
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "#000",
                            textTransform: "none",
                            whiteSpace: "nowrap",
                            padding: "4px 8px",
                            minWidth: "80px",
                            fontSize: "0.8rem"
                          }}
                          onClick={() => {
                            const studyId = localStorage.getItem("studyId");
                            this.props.history.push({
                              pathname: `/my_studies/overview/${studyId}/cell_step_management/${column.id}/add-step/question`,
                              state: { columnId: column.id, stepCategory: "Question" },
                            });
                          }}

                        >
                          + Question
                        </Button>
                      </Tooltip>


                      {/*add Validation */}
                      <Tooltip title="Add Validation Step" placement="top">
                        <Button
                          variant="contained"
                          disabled={addingValidation}
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "#000",
                            textTransform: "none",
                            whiteSpace: "nowrap",
                            padding: "4px 8px",
                            minWidth: "90px",
                            fontSize: "0.8rem",
                            opacity: addingValidation ? 0.6 : 1,
                          }}
                          onClick={this.onConfirmAddValidation}
                        >
                          + Validation
                        </Button>
                      </Tooltip>
                    </div>
                  </div>
                )}

              </TaskList>
            )}
          </Droppable>

        </Paper>
        {/* Render the duplicated column next to the original */}
        <Snackbar
          open={this.state.snackbarOpen}
          autoHideDuration={20000}
          onClose={this.handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={this.handleSnackbarClose}
            severity={this.state.snackbarSeverity}
            variant="outlined"
          >
            {this.state.snackbarMessage}
          </Alert>
        </Snackbar>
      </Root>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  addTask: (id, value, studyId, item, cacheId, name, newItem, applyToAllCells, template) =>
    dispatch(
      CellStepManagementOperations.addTask(
        id,
        value,
        studyId,
        item,
        cacheId,
        name,
        newItem,
        applyToAllCells,
        template
      )
    ),
});

export default withRouter(connect(null, mapDispatchToProps)(Column));
